import { Component } from 'react'

const CHUNK_RELOAD_KEY = 'pronto:chunk-error:last-reload'
const CHUNK_RELOAD_COOLDOWN = 60000

export const isChunkLoadError = error => /ChunkLoadError|Loading (CSS )?chunk [\s\S]*failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(`${error?.name || ''} ${error?.message || ''}`)

export default class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) return

    try {
      const now = Date.now()
      const lastReload = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY))
      if (lastReload && now - lastReload < CHUNK_RELOAD_COOLDOWN) return
      // Persist before reloading so a persistent failure cannot create a reload loop.
      window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now))
    } catch {
      // Keep manual recovery when storage is unavailable and retries cannot be tracked.
      return
    }

    window.location.reload()
  }

  render() {
    if (!this.state.error) return this.props.children
    const chunkFailure = isChunkLoadError(this.state.error)
    return (
      <main role='alert' style={{ maxWidth: 560, margin: '15vh auto', padding: 24, textAlign: 'center' }}>
        <h1>{chunkFailure ? 'No se pudo cargar esta pantalla' : 'Ocurrió un error al mostrar la aplicación'}</h1>
        <p>{chunkFailure ? 'Puede haber una actualización disponible o un problema de conexión. Verifica tu conexión y vuelve a cargar la aplicación.' : 'Vuelve a cargar la aplicación para intentarlo de nuevo.'}</p>
        <p>Al recargar, los cambios que no hayas guardado pueden perderse.</p>
        <button type='button' className='btn btn-primary' onClick={() => window.location.reload()}>
          Actualizar aplicación
        </button>
      </main>
    )
  }
}
